/**
 * App Creation Form Component
 * ============================
 * (unchanged comments kept)
 */
//testing 
import React from "react";
import { useNavigate } from "react-router-dom";
import { useAppStore } from "../store/useAppStore";
import apiService from "../services/apiService";
import StepLoader from "./StepLoader";
import Header from "./Header/Header";
// import { useAuthStore } from "../store/useAuthStore";
// fixed/updated by ChatGPT on 2025-10-19 10:16:02 â€" import auth store to pass createdBy uid
import { useAuthStore } from "../store/useAuthStore";

const AppCreationForm = () => {
  const navigate = useNavigate();
  
  const {
    appName,
    appDesc,
    setAppName,
    setAppDesc,
    setCollections,
    setGeneratedJSON,
    setCurrentStep,
  } = useAppStore();

  // App type selection state
  const [appType, setAppType] = React.useState('webapp'); // default to webapp

  // fixed/updated by ChatGPT on 2025-10-19 10:16:02 â€“ pull uid from auth store
  const getUid = useAuthStore(state => state.getUid);
  const initAuth = useAuthStore(state => state.init);
  const user = useAuthStore(state => state.user);
  React.useEffect(() => { initAuth?.(); }, [initAuth]);

  const notify = (message, level = "info") => {
    const prefix =
      level === "error" ? "❌" : level === "success" ? "🎉" : "ℹ️";
    console[level === "error" ? "error" : "log"](`${prefix} ${message}`);
    if (level !== "info") alert(`${prefix} ${message}`);
  };

  const handleStart = async (e) => {
    e.preventDefault();
    
    if (!appName || !appDesc) {
      notify("Please fill App Name & Description", "error");
      return;
    }

    // fixed/updated by ChatGPT on 2025-10-19 10:16:02 â€“ ensure user is present and uid is available
    const uid = getUid?.();
    if (!uid) {
      notify("You must be signed in to create an app.", "error");
      return;
    }

    try {
      setCurrentStep(0);

      console.log("🔍 [AppCreationForm] Checking backend connectivity...");
      setCurrentStep(1);
      try {
        const response = await fetch((process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000') + '/health');
        if (!response.ok) throw new Error('Backend not responding');
        console.log("✅ [AppCreationForm] Backend is reachable");
      } catch (error) {
        setCurrentStep(null);
        notify("Backend API not reachable. Make sure backend is running on port 5000.", "error");
        console.error("❌ [AppCreationForm] Backend check failed:", error);
        return;
      }

      console.log("🔔 [AppCreationForm] Creating app via backend API...");
      setCurrentStep(2);
      
      let appResult;
      try {
        // appResult = await apiService.createApp({ appName, description: appDesc });
        // fixed/updated by ChatGPT on 2025-10-19 10:16:02 â€“ include createdBy=uid so backend maps ownership
        appResult = await apiService.createApp({
          appName,
          description: appDesc,
          appType: appType, // Include app type
          createdBy: uid
        });

        console.log("✅ [AppCreationForm] App created successfully:", appResult);
        setCollections(appResult.collections);
      } catch (error) {
        setCurrentStep(null);
        notify(`Failed to create app: ${error.message}`, "error");
        console.error("❌ [AppCreationForm] App creation failed:", error);
        return;
      }

      console.log("✨ [AppCreationForm] App setup complete, navigating to Setup Wizard...");
      setGeneratedJSON({ content: {}, pages: [], components: [], layouts: {}, theme: {} });
      
      setCurrentStep(9);
      notify("Done! Your app is ready for setup!", "success");
      
      setTimeout(() => {
        setCurrentStep(null);
        console.log(`🚀 [AppCreationForm] Navigating to Setup Wizard for app: ${appName}`);
        // Redirect to setup wizard - AI generation happens after asset upload
        navigate(`/setup-wizard/${appName}/welcome?appType=${appType}`);
      }, 1200);
      
    } catch (err) {
      console.error("❌ [AppCreationForm] Unexpected error:", err);
      setCurrentStep(null);
      notify("Unexpected error occurred", "error");
    }
  };

  return (
    <>
      {/* Unified Header with MUDUMBAI logo and profile icon */}
      <Header />
      <div className="creation-mode">
        <div className="app-wrapper">
        <form className="app-form" onSubmit={handleStart}>
          <h1 className="app-title">🚀 Create Your App</h1>

          <label className="app-label" htmlFor="appName">App Name</label>
          <input
            id="appName"
            className="app-input"
            type="text"
            placeholder="Enter app name"
            value={appName}
            onChange={(e) => setAppName(e.target.value)}
          />

          <label className="app-label" htmlFor="appDesc">Description</label>
          <input
            id="appDesc"
            className="app-input"
            type="text"
            placeholder="Enter app description"
            value={appDesc}
            onChange={(e) => setAppDesc(e.target.value)}
          />

          {/* App Type Selection */}
          <label className="app-label" style={{ marginTop: '20px' }}>Application Type</label>
          <div style={{ display: 'flex', gap: '12px', marginBottom: '16px' }}>
            <button
              type="button"
              onClick={() => setAppType('static')}
              style={{
                flex: 1,
                padding: '16px',
                border: appType === 'static' ? '2px solid #10B981' : '2px solid #E5E7EB',
                borderRadius: '8px',
                backgroundColor: appType === 'static' ? '#D1FAE5' : 'white',
                cursor: 'pointer',
                textAlign: 'left',
                transition: 'all 0.2s'
              }}
            >
              <div style={{ fontSize: '24px', marginBottom: '8px' }}>🌐</div>
              <div style={{ fontWeight: '600', marginBottom: '4px' }}>Static Website</div>
              <div style={{ fontSize: '12px', color: '#6B7280' }}>Portfolio, blog, landing page</div>
            </button>
            
            <button
              type="button"
              onClick={() => setAppType('webapp')}
              style={{
                flex: 1,
                padding: '16px',
                border: appType === 'webapp' ? '2px solid #3B82F6' : '2px solid #E5E7EB',
                borderRadius: '8px',
                backgroundColor: appType === 'webapp' ? '#DBEAFE' : 'white',
                cursor: 'pointer',
                textAlign: 'left',
                transition: 'all 0.2s'
              }}
            >
              <div style={{ fontSize: '24px', marginBottom: '8px' }}>📱</div>
              <div style={{ fontWeight: '600', marginBottom: '4px' }}>Web Application</div>
              <div style={{ fontSize: '12px', color: '#6B7280' }}>Forms, data, simple workflows</div>
            </button>
            
            <button
              type="button"
              onClick={() => setAppType('enterprise')}
              style={{
                flex: 1,
                padding: '16px',
                border: appType === 'enterprise' ? '2px solid #EC4899' : '2px solid #E5E7EB',
                borderRadius: '8px',
                backgroundColor: appType === 'enterprise' ? '#FCE7F3' : 'white',
                cursor: 'pointer',
                textAlign: 'left',
                transition: 'all 0.2s'
              }}
            >
              <div style={{ fontSize: '24px', marginBottom: '8px' }}>🏢</div>
              <div style={{ fontWeight: '600', marginBottom: '4px' }}>Enterprise App</div>
              <div style={{ fontSize: '12px', color: '#6B7280' }}>Complex workflows, processes</div>
            </button>
          </div>

          {/* fixed/updated by ChatGPT on 2025-10-19 10:16:02 â€“ subtle UI: show who will be app owner */}
          {user && (
            <div style={{ marginTop: 8, fontSize: 12, color: '#4b5563' }}>
              Owner (createdBy): <strong>{user.email || user.uid || 'current user'}</strong>
            </div>
          )}

          <button type="submit" className="app-button">
            Let's Start
          </button>

          <a
            href="/admin"
            style={{
              display: 'block',
              marginTop: '20px',
              padding: '12px',
              textAlign: 'center',
              fontSize: '14px',
              color: '#DC2626',
              backgroundColor: '#FEF2F2',
              border: '2px solid #FCA5A5',
              borderRadius: '8px',
              textDecoration: 'none',
              fontWeight: '600',
              transition: 'all 0.2s'
            }}
            onMouseOver={(e) => {
              e.target.style.backgroundColor = '#FEE2E2';
              e.target.style.borderColor = '#DC2626';
            }}
            onMouseOut={(e) => {
              e.target.style.backgroundColor = '#FEF2F2';
              e.target.style.borderColor = '#FCA5A5';
            }}
          >
            ⚙️ Admin Panel
          </a>
        </form>
        </div>

        <StepLoader />
      </div>
    </>
  );
};

export default AppCreationForm;

